export const DISPLAY_PROFILE_PAGE_KEY = "display_profile_creator";

// Keep in sync with web_admin/src/views/pages/PageBuilder/sectionSchemas.js.
// Only the logged-out guide is built from these sections; the theme also styles the logged-in views.
// Empty fonts mean "keep the site fonts", so nothing changes until an admin picks one.
export const DEFAULT_DISPLAY_PROFILE_LAYOUT = {
  theme: {
    headingFont: "",
    bodyFont: "",
    primaryColor: "#EC1F24",
  },
  sections: [
    {
      id: "hero",
      type: "profileHero",
      visible: true,
      style: {},
      props: {
        title: "Display Your Profile to Clients",
        text: "Track your profile completion, see what is missing, and know exactly when your creator profile is ready to be found by organisations, brands and people hiring on KUVUMA.",
      },
    },
    {
      id: "requirements",
      type: "profileRequirements",
      visible: true,
      style: {},
      props: {
        heading: "What you need to complete",
      },
    },
    {
      // Card icons are fixed by position.
      id: "features",
      type: "profileFeatures",
      visible: true,
      style: {},
      props: {
        heading: "What you can see after login",
        cards: [
          { title: "Completion Progress", text: "A percentage bar showing how complete your creator profile is." },
          { title: "Profile Details", text: "Check your basic details, profession, experience and education." },
          { title: "Photo & Portfolio", text: "See whether your profile photo and portfolio or work sample are in place." },
          { title: "Location Status", text: "Confirm your location is set so nearby clients can discover you." },
          { title: "Documents Checklist", text: "View which verification documents are uploaded and which are still required." },
          { title: "Missing Requirements", text: "A clear list of what to fix next, with direct links to update each item." },
        ],
      },
    },
    {
      id: "statusPreview",
      type: "profileStatusPreview",
      visible: true,
      style: {},
      props: {
        heading: "Preview of your profile status",
        cardTitle: "Profile Completion",
      },
    },
    {
      id: "benefits",
      type: "profileBenefits",
      visible: true,
      style: {},
      props: {
        heading: "How this helps you on KUVUMA",
        cards: [
          { title: "Get found by clients", text: "A complete profile helps organisations and brands find you when they search for creators." },
          { title: "Know exactly what to fix", text: "No guesswork. See what is missing and jump straight to the page where you can add it." },
          { title: "Get verified", text: "Upload your documents so the admin team can verify your account." },
          { title: "Stronger applications", text: "Apply to opportunities with a profile that shows your skills, work and rates." },
        ],
      },
    },
    {
      id: "cta",
      type: "profileCta",
      visible: true,
      style: {},
      props: {
        heading: "Ready to check your profile status?",
        text: "Login to view your completion progress and missing requirements, or register free to start building a profile that gets you discovered on KUVUMA.",
        loginButton: "Login",
        registerButton: "Register Free",
      },
    },
  ],
};
